<template>
  <div class="seller-contract" v-loading="fuck_loading" element-loading-background="rgba(255, 255, 255, 0.98)">
    <div class="seller-top">
      <div class="top-con">
        <div class="container">
          <img src="@/assets/image/Contract/sell-title.png"/>
          <span>订单编号：{{ form.order_sn }}</span>
        </div>
        <div class="logo"></div>
      </div>
    </div>
    <div class="seller-main">
      <div class="form">
        <el-form ref="form" label-position="top" label-width="200px" :model="form" :rules="rules">
          <!-- <div class="contract_order_sn">
            订单编号：{{ form.order_sn }}
          </div> -->
          <el-form-item prop="source" class="contract_radio">
            <div slot="label" class="item-label">
              <i>您是从哪里知晓游严选游戏服务网的？</i>
              <i class="item-radio">(单选)</i>
            </div>
            <el-radio  label="1" v-model="form.source">贴吧</el-radio>
            <el-radio  label="2" v-model="form.source">主播</el-radio>
            <el-radio  label="3" v-model="form.source">号商</el-radio>
            <el-radio  label="4" v-model="form.source">朋友推荐</el-radio>
            <el-radio  label="5" v-model="form.source">网页搜索</el-radio>
            <el-radio  label="6" v-model="form.source">小程序公众号</el-radio>
            <el-radio  label="7" v-model="form.source">抖音</el-radio>
            <el-radio  label="8" v-model="form.source">B站(bilbili)</el-radio>
            <el-radio  label="9" v-model="form.source">老客户</el-radio>
            <el-radio  label="10" v-model="form.source">微博</el-radio>
            <el-radio  label="0" v-model="form.source">其他</el-radio>
            <el-radio style="visibility: hidden" disabled label="11" v-model="form.source"></el-radio>
          </el-form-item>
          <el-form-item label="身份证照片" prop="frontIdPhoto" class="form-item-id-card ">
            <div class="id-card">
              <el-upload
                v-loading="loading"
                action
                :disabled="!frontIdPhotoShow"
                :style="!frontIdPhotoShow ? 'cursor:not-allowed;' : ''"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="upload">
                <div class="img-box" v-show="form.frontIdPhoto !== ''">
                  <img :src="frontIdPhoto_url">
                  <div class="mask" v-show="frontIdPhotoShow">
                    <span>重新上传</span>
                  </div>
                </div>
              </el-upload>
              <!-- <div class="img-box" v-show="form.frontIdPhoto !== ''">
                <img :src="form.frontIdPhoto">
                <div class="mask" v-show="frontIdPhotoShow">
                  <span>重新上传</span>
                </div>
              </div>
              <input type="file" @change="upload" :disabled="!frontIdPhotoShow" :style="!frontIdPhotoShow ? 'cursor:not-allowed;' : ''"> -->
            </div>
          </el-form-item>
          <el-form-item label="" prop="backIdPhoto" class="form-item-id-card">
            <div class="id-card id-card-back">
              <el-upload
                v-loading="loadingback"
                action
                :disabled="!backIdPhotoShow"
                :style="!backIdPhotoShow ? 'cursor:not-allowed;' : ''"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="uploadCardBehind">
                <div class="img-box" v-show="form.backIdPhoto !== ''">
                  <img :src="backIdPhoto_url">
                  <div class="mask" v-show="backIdPhotoShow">
                    <span>重新上传</span>
                  </div>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input placeholder="上传身份证后显示" v-model="form.name" :disabled="nameShow"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="card_id">
            <el-input placeholder="上传身份证后显示" v-model="form.card_id" :disabled="cardIdShow"></el-input>
          </el-form-item>
          <el-form-item label="现住地址" prop="address">
            <el-input placeholder="请输入现住地址" v-model="form.address" type="textarea" :rows="3" resize="none"></el-input>
          </el-form-item>
          <el-form-item label="通讯地址" prop="card_address">
            <el-input placeholder="请输入身份证上的地址" v-model="form.card_address" type="textarea" :rows="3"
                resize="none"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="mobile">
            <el-input placeholder="请输入联系电话" v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱(如没有邮箱请跳过)" prop="email">
            <el-input placeholder="请输入电子邮箱" v-model="form.email"></el-input>
          </el-form-item>
          <!-- <el-form-item label="游戏账号" prop="sell_game_account">
            <el-input placeholder="请输入游戏账号" v-model="form.sell_game_account"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="法大大注册账号" prop="fdd_account">
            <el-input placeholder="请输入法大大注册账号" v-model="form.fdd_account"></el-input>
          </el-form-item> -->
          <el-form-item prop="charge_account">
            <span slot="label" class="payee-tip">
              转让方指定收款账号
              <img src="@/assets/image/Contract/payee_tip.png" @click="payeeTipVisible = true"/>
            </span>
            <el-input placeholder="请输入收款账号" v-model="form.charge_account">
              <el-select v-model="form.charge_account_type" slot="append" placeholder="请选择">
                <el-option label="支付宝" :value="0"></el-option>
                <el-option label="微信" :value="1"></el-option>
                <el-option label="银行卡" :value="2"></el-option>
              </el-select>
            </el-input>
            <div class="point">
              默认支付宝收款，其他收款方式请重新选择，<span>一经放款概不负责！</span>
            </div>
          </el-form-item>
          <el-form-item label="收款人姓名" prop="payee_name">
            <el-input placeholder="请输入收款人姓名" v-model="form.payee_name"></el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="note">
            <el-input placeholder="请输入备注信息" v-model="form.note" type="textarea" :rows="3" resize="none"></el-input>
          </el-form-item>
          <div class="fdd-tip">
            <img src="@/assets/image/Contract/fddTip.png"/>
            本平台电子合同由法大大提供技术支持
          </div>
        </el-form>
      </div>
      <div class="seller-btn">
        <el-button @click="resetForm()" class="reset">重填</el-button>
        <el-button type="primary" :loading="isSave" @click="save()" class="sub">提交</el-button>
      </div>
    </div>
    <el-dialog
      title="温馨提示"
      :visible.sync="payeeTipVisible"
      custom-class="payeeTipDia myDialog myDialog--header"
      center
      top="25vh">
      <div class="payee-content">
        <p>转让方须提供真实有效的收款账号和收款人姓名（即转让方本人收款账号、姓名或转让方指定的收款账号、收款人姓名）。</p>
        <p>若因收款账号、收款人姓名错误产生的转款风险由转让方承担。</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiSellContract,
  apiSellCard,
  appUploadAuth,
  appUploadAuthCardBehind,
  apiuserContract,
  apiContractDetails,
  appAliyunAuth
  } from "../../request/API";
import * as imageConversion from 'image-conversion'
/**
 * 表单验证失败时 滚动到第一个error位置
 */
const scrollIntoView = (className = "is-error", block = "center") => {
    Promise.resolve().then(() => {
       const target = document.getElementsByClassName(className);
     if (target.length) {
        target[0].scrollIntoView({
           behavior: "smooth",
           block: block,
       });
    }
  });
};
export default {
  name: 'sellerContract',
  data() {
    return {
      payeeTipVisible: false,
      loading: false,
      loadingback: false,
      fuck_loading: true,
      form: {
        charge_account_type: 0,
        contract_id: '',
        order_sn: '',
        name: '',
        card_id: '',
        address: '',
        card_address: '',
        mobile: '',
        email: '',
        sell_game_account: '1',
        fdd_account: '1',
        charge_account: '',
        payee_name: '',
        frontIdPhoto: '',
        backIdPhoto: '',
        note: '',
        source: '',
      },
      frontIdPhoto_url: '',
      backIdPhoto_url: '',
      rules: {
        // name: [
        //   {required: true, message: '请输入姓名', trigger: 'blur'},
        //   { max: 30, message: '姓名不得超过30个汉字', trigger: 'blur' }
        // ],
        payee_name: [
          {required: true, message: '请输入收款人姓名', trigger: 'blur'},
          { max: 30, message: '姓名不得超过30个汉字', trigger: 'blur' }
        ],
        // card_id: [
        //   {required: true, message: '请输入身份证号', trigger: 'blur'},
        //   { min: 18, max: 18, message: '请输入18位身份证号', trigger: 'blur' }
        // ],
        address: [
          {required: true, message: '请输入现住地址', trigger: 'blur'},
          { min: 5, max: 100, message: '请输入5~100个字的准确现住地址', trigger: 'blur' }
        ],
        card_address: [
          {required: true, message: '请输入通讯地址', trigger: 'blur'},
          { min: 5, max: 100, message: '请输入5~100个字的准确现住地址', trigger: 'blur' }
        ],
        mobile: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {min:11, max: 11, message: '请输入11位手机联系号码', trigger: 'blur' }
        ],
        email: [
          { max: 50, message: '邮箱地址不得超过50位', trigger: 'blur' }
          // {required: true, message: '请输入电子邮箱', trigger: 'blur'},
        ],
        // sell_game_account: [
        //   {required: true, message: '请输入游戏账号', trigger: 'blur'},
        // ],
        // fdd_account: [
        //   {required: true, message: '请输入法大大注册账号', trigger: 'blur'},
        // ],
        charge_account: [
          {required: true, message: '请输入收款账号', trigger: 'blur'},
          { max: 70, message: '收款账号不得超过70个字符', trigger: 'blur' }
        ],
        frontIdPhoto: [
          {required: true, message: '请上传身份证人像面照片', trigger: 'change'},
        ],
        backIdPhoto: [
          {required: true, message: '请上传身份证国徽面照片', trigger: 'change'},
        ],
        source: [
          {required: true, message: '请选择选项', trigger: 'change'},
        ],
      },
      isSave: false,
      frontIdPhotoShow: true,
      backIdPhotoShow: true,
      nameShow: true,
      cardIdShow: true,
      userToken: '',
      app_status: 1,
      fdd_auth: 0
    }
  },
  created() {
    this.userToken = this.$route.query?.t || this.$route.query?.token
    this.form.contract_id = this.$route.query.contract_id
    if(this.userToken){
      let status = true
      this.$store.commit('set_token', this.userToken)
      this.$store.commit('set_loginStatus', status)
      this.app_status = 2
    } else{
      if (this.$store.state.loginStatus) {
        this.app_status = 1
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.path+'?contract_id='+this.form.contract_id,
          },
        })
        return;
      }
    }

    apiuserContract(this.app_status).then(res => {
      const data = res.data || {}
      this.fdd_auth = data.fdd_auth || 0
      if(this.fdd_auth==1){
        this.form.name = data.name
        this.form.card_id = data.card_id
      }else{
        this.form.name = ''
        this.form.card_id = ''
      }
      this.form.charge_account_type = data.charge_account_type || 0
      // this.form.name = res.data.name || ''
      // this.form.name == '' ? this.nameShow = false : this.nameShow = true
      // this.form.card_id = res.data.card_id || ''
      // this.form.card_id == '' ? this.cardIdShow = false : this.cardIdShow = true
      this.form.address = data.address || ''
      this.form.card_address = data.card_address || ''
      this.form.email = data.email || ''
      this.form.fdd_account = data.fdd_account || '1'
      this.form.charge_account = data.charge_account || ''
      this.form.payee_name = data.payee_name || ''
      if(this.form.name == '' || this.form.card_id == ''){
        this.form.frontIdPhoto = ''
        this.frontIdPhoto_url = ''
        this.frontIdPhotoShow = true
        this.form.backIdPhoto = ''
        this.backIdPhoto_url = ''
        this.backIdPhotoShow = true
      }else{
        this.form.frontIdPhoto = data.frontIdPhoto || ''
        this.frontIdPhoto_url = data.frontIdPhoto_url || ''
        this.frontIdPhoto_url == '' ? this.frontIdPhotoShow = true : this.frontIdPhotoShow = false
        this.form.backIdPhoto = data.backIdPhoto || ''
        this.backIdPhoto_url = data.backIdPhoto_url || ''
        this.backIdPhoto_url == '' ? this.backIdPhotoShow = true : this.backIdPhotoShow = false
      }
      this.form.note = data.note || ''
      this.form.mobile = data.mobile || ''
      this.fdd_auth = data.fdd_auth || 0
    }).catch(err => {
      this.$message({
        message: (err && err.msg) || '用户合同信息获取失败，请稍后重试',
        center: true,
        offset: 200,
        customClass: 'sell-contract-msg'
      })
    })

    // 获取订单编号
    apiContractDetails(this.app_status,{contract_id: this.$route.query.contract_id,iden:2}).then(res => {
      const data = res.data || {}
      this.form.order_sn = data.order_sn || ''
      let already = data.sell_user_id
      setTimeout(() => {
        this.fuck_loading = false
      }, 400);
      if (this.$store.state.loginStatus){
        if(this.userToken){
          if(already !== null && already !=='' && already !== 0){
            location.href = `/submitSuccess?contract_id=${this.form.contract_id}&type=2&already=1&app_status=${this.app_status}`
          }
        } else {
          let tel = data.sell_nickname || ''
          if(tel != this.$store.state.userData.telphone){
            let telStart = tel.substring(0,3)
            let telEnd = tel.substring(7,11)
            this.$alert('当前用户无此合同编号，请重新登录'+ telStart + '****' + telEnd +'后填写',{
              confirmButtonText: '确定',
              center: true,
              showClose: false
            }).then(() => {
              this.$router.push({
                path: '/login',
                query: {
                  Rurl: this.$route.path+'?contract_id='+this.form.contract_id,
                },
              })
            }).catch(() => {})
            setTimeout(() => {
              let dom = document.querySelector('.v-modal')
              if(dom){
                dom.style.opacity= '.93'
              }
            },400)
          }else{
            if(already !== null && already !=='' && already !== 0){
              location.href = `/submitSuccess?contract_id=${this.form.contract_id}&type=2&already=1&app_status=${this.app_status}`
            }
          }
        }
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.path+'?contract_id='+this.form.contract_id,
          },
        })
      }
    }).catch(err => {
      this.fuck_loading = false
      if(err && err.code == 10001){
        this.$message({
          message: err.msg,
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        setTimeout(() => {
          this.$router.push({
            path: '/login',
            query: {
              Rurl: this.$route.path+'?contract_id='+this.form.contract_id,
            },
          })
        }, 3000)
      }else{
        this.$message({
          message: (err && err.msg) || '合同详情获取失败，请稍后重试',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
      }
    })
  },
  methods: {
    resetForm() {
      let name = this.form.name
      let card_id = this.form.card_id
      let frontIdPhoto = this.form.frontIdPhoto
      this.$refs['form'].resetFields();
      this.form.name = name
      this.form.card_id = card_id
      this.form.frontIdPhoto = frontIdPhoto
      this.form.mobile = ''
      // this.nameShow = false
      // this.cardIdShow = false
      this.frontIdPhotoShow = true
      this.backIdPhotoShow = true
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.isSave = true
          apiSellContract(this.app_status,{...this.form,return_url: ''}).then(res => {
            // return
            if(res.data.url){
              location.href = res.data.url
            }else{
              location.href = `/submitSuccess?contract_id=${this.form.contract_id}&type=2&app_status=${this.app_status}`
            }
            this.isSave = false
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.isSave = false
          })
        }else{
          scrollIntoView()
          this.$message({
            message: '还有未填项',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
        }
      })
    },
    /**
     * @description: 生成唯一标识
     * @return {*}
     */
    uuid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        let uuid = s.join("");
        return uuid;
    },
    async upload(file) {
      this.loading = true
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message({
          message: '上传图片只能是 JPG/PNG 格式!',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 900,
        type: 'image/jpeg'
      })
      let blob_file = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      // this.$getBase64(newFile).then(res => {
        // appUploadAuth(this.app_status,{
        //   file:res
        // }).then(res=>{
        //   if(this.form.card_id!=''&&this.form.card_id!=null&&this.form.card_id!=res.data.cert_id){
        //     this.$message({
        //       message: '上传身份证与法大大实名不一致',
        //       center: true,
        //       offset: 200,
        //       customClass: 'sell-contract-msg'
        //     })
        //     this.loading = false
        //     this.frontIdPhoto_url = ''
        //     return
        //   }
          let formData = new FormData()
          formData.append('file', blob_file)
          apiSellCard(this.app_status,formData).then(resp => {
            appAliyunAuth(this.app_status,{
              url: resp.data.url
            }).then(res => {
              if(this.form.card_id!=''&&this.form.card_id!=null&&this.form.card_id!=res.data.cert_id){
                this.$message({
                  message: '上传身份证与法大大实名不一致',
                  center: true,
                  offset: 200,
                  customClass: 'sell-contract-msg'
                })
                this.loading = false
                this.frontIdPhoto_url = ''
                return
              } else {
                this.form.frontIdPhoto = resp.data.uri
                this.frontIdPhoto_url = resp.data.url
                this.form.name = res.data.cert_name
                this.form.card_id = res.data.cert_id
                if(this.form.name == '' || this.form.card_id == ''){
                  this.frontIdPhoto_url = ''
                  this.$message({
                    message: '验证失败，请重新上传',
                    center: true,
                    offset: 200,
                    customClass: 'sell-contract-msg'
                  })
                } else {
                  // this.nameShow = true
                  // this.cardIdShow = true
                  this.frontIdPhotoShow = false
                  this.$message({
                    message: '验证通过',
                    center: true,
                    offset: 200,
                    customClass: 'sell-contract-msg'
                  })
                }
                this.loading = false
              }
            }).catch(err => {
              this.$message({
                message: err.msg,
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
              this.loading = false
            })
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.loading = false
          })
        // }).catch(err=>{
        //   this.$message({
        //     message: err.msg,
        //     center: true,
        //     offset: 200,
        //     customClass: 'sell-contract-msg'
        //   })
        //   this.loading = false
        // })
      // });
    },
    async uploadCardBehind(file) {
      this.loadingback = true
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message({
          message: '上传图片只能是 JPG/PNG 格式!',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 900,
        type: 'image/jpeg'
      })
      let blob_file = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      this.$getBase64(newFile).then(res => {
        appUploadAuthCardBehind(this.app_status,{
          file:res
        }).then(res=>{
          let formData = new FormData()
          formData.append('file', blob_file)
          apiSellCard(this.app_status,formData).then(resp => {
            this.form.backIdPhoto = resp.data.uri
            this.backIdPhoto_url = resp.data.url
            this.backIdPhotoShow = false
            this.$message({
              message: '验证通过',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.loadingback = false
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.loadingback = false
          })
        }).catch(err=>{
          this.$message({
            message: err.msg,
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          this.loadingback = false
        })
      });
    },
    // upload(e) {
    //   if (e.target.files.length > 0) {
    //     let formData = new FormData()
    //     formData.append('file', e.target.files[0])
    //     apiSellCard(formData).then(res => {
    //       this.form.frontIdPhoto = res.data.file_path
    //     }).catch(err => {
    //       this.$message.error(err.msg)
    //     })
    //   }
    // }
  }
}
</script>

<style lang="less">
@import "./styles/contractFeedback.less";
</style>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page();

.seller-contract {
  /deep/ .payeeTipDia.myDialog {
    width: 386px;
    border-radius: 4px;
    overflow: hidden;
    border: 0;
    background: var(--bg-card, #FFFFFF);
    box-shadow: none;
    filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

    .el-dialog__header {
      height: 54px;
      padding: 0;
      background: var(--bg-dark, #1A1D24);
      border-radius: 4px 4px 0 0;
      border-bottom: none;
      text-align: center;
    }

    .el-dialog__title {
      font-size: 18px;
      line-height: 54px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      letter-spacing: 1px;
    }

    .el-dialog__headerbtn {
      top: 17px;
      right: 20px;
      width: 20px;
      height: 20px;

      .el-dialog__close {
        color: rgba(255, 255, 255, 0.86);
        font-size: 18px;
        transition: color .2s ease, transform .2s ease;
      }

      &:hover .el-dialog__close {
        color: #FFFFFF;
        transform: rotate(90deg);
      }
    }

    .el-dialog__body {
      padding: 0;
      background: var(--bg-card, #FFFFFF);
      border-radius: 0 0 4px 4px;
    }

    .payee-content {
      padding: 24px 30px 28px;
      border-radius: 0 0 4px 4px;
      background: var(--bg-card, #FFFFFF);

      p {
        margin: 0;
        position: relative;
        padding-left: 14px;
        line-height: 24px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);

        & + p {
          margin-top: 10px;
        }

        &::before {
          content: ' ';
          position: absolute;
          left: 0;
          top: 7px;
          width: 5px;
          height: 10px;
          border-radius: 4px;
          background: var(--primary, #FF5A1F);
        }
      }
    }
  }

  .seller-main {
    .form {
      /deep/ .el-form-item {
        .el-form-item__label {
          .payee-tip{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img{
              width: 17px;
              height: 17px;
              margin-left: 6px;
              cursor: pointer;
              transition: opacity .2s ease, transform .2s ease;

              &:hover {
                opacity: .82;
                transform: scale(1.06);
              }
            }
          }
        }
      }

      .id-card {
        background-image: url("~@/assets/image/Contract/IDCard.jpg");
      }
    }
  }

  @media screen and (max-width: 500px) {
    /deep/ .payeeTipDia.myDialog{
      width: 85vw;
    }
  }
}
</style>
